import { render } from "./EditorView.vue?vue&type=template&id=76050026&scoped=true&ts=true"
import script from "./EditorView.vue?vue&type=script&lang=ts"
export * from "./EditorView.vue?vue&type=script&lang=ts"

import "./EditorView.vue?vue&type=style&index=0&id=76050026&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\miauerka\\web-projects\\mimafi-project\\mimawebapp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76050026"]])

export default __exports__